import jQuery from 'jquery';

global.$ = jQuery;
global.jQuery = jQuery;
